import KindAttributes from "./KindAttributes";
import Kind from "./kind";
import KindPicker from "./KindPicker";

export default {
  KindAttributes,
  Kind,
  KindPicker
};
